/**
 * Created by jonas on 2021-02-19.
 */
import {DasUBootSymbol, DasUBootSymbolStates} from "../reels/DasUBootSymbol";
import {DasUBootGameAssets} from "../DasUBootGameAssets";
import {DasUBoot} from "../DasUBoot";
import {TorpedoPart} from "./parts/TorpedoPart";
import {gsap} from "gsap";
import {GraphicsPool} from "../utils/GraphicsPool";
import {DasUBootReel} from "../reels/DasUBootReel";
import {
    SimpleReelModelState,
    SimpleReelModelSymbolData,
    SimpleReelModelSymbolPosition
} from "../../core/reel/simplereel/SimpleReelModel";
import {SpriteUtils} from "../utils/SpriteUtils";
import {isTorpedoSymbol, TorpedoSymbol} from "../reels/symbols/TorpedoSymbol";
import {DasUBootSound} from "../sound/DasUBootSound";
import {MiniLampState} from "./parts/SpineLamp";
import {SpineGSAPWrapper} from "../../core/animation/SpineGSAPWrapper";


export class DasUBootTorpedoView {
    private openHatchAnimation:gsap.core.Timeline;
    private isHatchOpen:boolean = false;
    private torpedoBottomContainer:PIXI.Container;
    private torpedoTopContainer:PIXI.Container;
    private _launchSpine:PIXI.spine.Spine;


    private _torpedo:PIXI.Container;
    public stickySymbols:SimpleReelModelSymbolData[];
    public backgroundView:PIXI.Container;
    public topView:PIXI.Container;

    public position:PIXI.ObservablePoint = new PIXI.ObservablePoint(this.onPosition, this);
    public pivot:PIXI.ObservablePoint = new PIXI.ObservablePoint(this.onPivot, this);

    private torpedoParts:{[index:number]:TorpedoPart | undefined};
    private propeller:{still:PIXI.Sprite; anim:PIXI.AnimatedSprite} | undefined;

    private onPosition() {
        this.backgroundView.position.set(this.position.x, this.position.y);
        this.topView.position.set(this.position.x, this.position.y);
    }

    private onPivot() {
        this.backgroundView.pivot.set(this.pivot.x, this.pivot.y);
        this.topView.pivot.set(this.pivot.x, this.pivot.y);
    }

    get visible():boolean {
        return this.topView.visible;
    }

    set visible(value:boolean) {
        this.backgroundView.visible = value;
        this.topView.visible = value;
    }

    constructor(background:PIXI.Container, foreground:PIXI.Container) {
        this.torpedoBottomContainer = background;
        this.torpedoTopContainer = foreground;


        this.backgroundView = new PIXI.Container();
        this.backgroundView.name = "TorpedoBackView";
        this.topView = new PIXI.Container();
        this.topView.name = "TorpedoTopView";

        this.stickySymbols = [];
        this.torpedoParts = {};

        this.backgroundView.addChild(SpriteUtils.make(DasUBootGameAssets.TORPEDO_BACKGROUND, new PIXI.Point(-68, 226)));

        this.openHatchAnimation = this.createHatchAnimation();

        this._launchSpine = GraphicsPool.spineFactory(DasUBootGameAssets.TORPEDO_BUBBLES_SPINE);
        this._launchSpine.position.set(430, 526);
        this.topView.addChild(this._launchSpine);
    }

    private createHatchAnimation() {
        const hatchRight = SpriteUtils.make(DasUBootGameAssets.TORPEDO_BACKGROUND_HATCH, new PIXI.Point(864, 462), new PIXI.Point(0, 0));
        const hatchLeft = SpriteUtils.make(DasUBootGameAssets.TORPEDO_BACKGROUND_HATCH, new PIXI.Point(0, 462), new PIXI.Point(0, 0));
        hatchRight.pivot.set(10, 20)
        hatchLeft.pivot.set(10, 20)
        hatchLeft.scale.set(-1, 1);

        this.backgroundView.addChild(hatchRight);
        this.backgroundView.addChild(hatchLeft);

        const hatchAnimation = gsap.timeline({paused:true});
        hatchAnimation.addLabel("start");
        hatchAnimation.add([
            gsap.to(hatchRight, {duration:0.6, rotation:-Math.PI * 0.5}),
            gsap.to(hatchLeft, {duration:0.6, rotation:Math.PI * 0.5})
        ]);
        hatchAnimation.addLabel("end");
        return hatchAnimation;
    }


    public activatePart(duration:number, reelId:number, finalSize:number, fallSize:number, fromReelPos:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();


        let landingSymbol:TorpedoSymbol | undefined;
        if (isTorpedoSymbol(DasUBoot.reelView.getVisibleSymbolAt(reelId, fromReelPos).positionable)) {
            landingSymbol = <TorpedoSymbol>DasUBoot.reelView.getVisibleSymbolAt(reelId, fromReelPos).positionable;
        }


        const part = this.createTorpedoPart(reelId, fallSize, fromReelPos);

        tl.add(() => {
            this._torpedo.addChild(part);
        });

        tl.add(() => {
            if (landingSymbol) {
                landingSymbol.removeTorpedoPart();
            }
        });

        tl.add(gsap.to(part, {duration:duration, y:451, ease:"power2.in"}));
        tl.add([
            () => part.setValue(finalSize),
            part.getWeld()
        ]);

        tl.add([
            this.createStickySymbol(reelId),
            //() => DasUBoot.reelView.reelFrame.switchMiniLamps(MiniLampState.YELLOW, [reelId])
        ]);
        tl.add(() => {
            this.replaceOldPart(reelId, part);
        });
        return tl;
    }

    private replaceOldPart(reelId:number, newPart:TorpedoPart) {
        if (this.torpedoParts[reelId] != undefined) {
            this._torpedo.removeChild(this.torpedoParts[reelId]!);
        }
        this.torpedoParts[reelId] = newPart;
    }

    public createTorpedoPart(reelId:number, size:number, fromReelPos:number):TorpedoPart {
        let isWild = false;
        if (reelId == 2 || reelId == 3) {
            isWild = true;
            fromReelPos -= 1;
        }

        const part = new TorpedoPart(size, isWild);
        const startPos = fromReelPos * 144;
        part.position.set(reelId * 144, startPos);

        return part;
    }

    public createStickySymbol(reelId:number):gsap.core.Timeline {
        let symbol:DasUBootSymbol;
        if (reelId == 1 || reelId == 4) {
            symbol = this.createSymbol("M", {reelID:reelId, position:3});
        } else {
            symbol = this.createSymbol("MW", {reelID:reelId, position:4});
        }

        return symbol.getStateAnimation(DasUBootSymbolStates.STICKY);
    }

    private createSymbol(symbolName:string, symbolPosition:SimpleReelModelSymbolPosition):DasUBootSymbol {
        const reel:DasUBootReel = DasUBoot.reelView.reels[symbolPosition.reelID];

        //returns already existing one
        for (let sym of this.stickySymbols) {
            if (sym.reelId == symbolPosition.reelID) {
                return <DasUBootSymbol>sym.positionable;
            }
        }

        const symbol:DasUBootSymbol = <DasUBootSymbol>reel.createSymbol(symbolName, SimpleReelModelState.IDLE, symbolPosition);
        //symbol.getStateAnimation(DasUBootSymbolStates.INVISIBLE)

        const symbolData:SimpleReelModelSymbolData = {
            name:symbolName,
            positionable:symbol,
            reelPosition:symbolPosition.position,
            reelId:symbolPosition.reelID
        }

        this.stickySymbols.push(symbolData);
        this.stickySymbols.sort((a:any, b:any) => {
            return (a.reelId < b.reelId) ? -1 : 1;
        });

        return symbol;
    }


    public getHatchAnimation(open:boolean):gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(gsap.to(this, {duration:0}));

        if (open && !this.isHatchOpen) {
            this.isHatchOpen = true;
            tl.add(() => DasUBoot.soundPlayer.playSound(DasUBootSound.TORPEDO_COVER_OPEN));
            tl.add(this.openHatchAnimation.tweenFromTo("start", "end"));

        }

        if (!open && this.isHatchOpen) {
            this.isHatchOpen = false;
            tl.add(() => DasUBoot.soundPlayer.playSound(DasUBootSound.TORPEDO_COVER_CLOSE));
            tl.add(this.openHatchAnimation.tweenFromTo("end", "start"));
        }


        return tl;

    }

    public launchTorpedo(duration:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this.topView.addChild(this._launchSpine);
            SpineGSAPWrapper.clearAllTracks(this._launchSpine);
            this._launchSpine.updateTransform();
        })

        tl.add(this.getPartFlash());
        tl.add(() => {DasUBoot.reelView.reelFrame.xBombMultiplierDisplay.incrementMultiplier(0.6, new PIXI.Point(390, 700))});
        tl.add([
            () => this.updatePropeller(true),
            gsap.to(this._torpedo, {duration:duration, x:1500, ease:"power2.in"}),
            SpineGSAPWrapper.createTimeline(this._launchSpine, 0, "launch"),
            () => DasUBoot.soundPlayer.playSound(DasUBootSound.TORPEDO_LAUNCH)
        ]);
        tl.add([
            DasUBoot.reelView.reelFrame.possibleWinWaysDisplay.setWinWays(DasUBoot.model.clientData.totalPossibleWinWays),
            this.getHatchAnimation(false)
        ])
        tl.add(() => {
            this.updatePropeller();
            this.topView.removeChild(this._launchSpine);
        })
        return tl;
    }

    public clearTorpedo(loadNewTorpedo:boolean = false):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => this.commitStickySymbolsToReel(true));

        tl.add(() => {
            DasUBoot.reelView.reelFrame.switchMiniLamps(MiniLampState.OFF, [0, 1, 2, 3, 4, 5]);
        })

        tl.add(this.getHatchAnimation(false))

        if (loadNewTorpedo) {
            tl.add(this.loadTorpedo());
        } else {
            tl.add(this.unLoadTorpedo());
        }


        tl.add(gsap.to(this, {duration:0.0001}));

        return tl;
    }


    public commitStickySymbolsToReel(hide:boolean) {
        const torpedoSymbols:SimpleReelModelSymbolData[] = this.stickySymbols;
        for (let symbolData of torpedoSymbols) {
            const symbol = <DasUBootSymbol>symbolData.positionable;
            symbol.reel.commitOverlayToReel(symbolData);
            if (hide) {
                symbol.getStateAnimation(DasUBootSymbolStates.START_SPIN);
                this.stickySymbols = [];
                this.torpedoParts = {};
            }
        }
    }


    private createBlankTorpedo():void {
        if (this._torpedo != undefined) {
            this.topView.removeChild(this._torpedo);
        }
        this._torpedo = new PIXI.Container();
        this._torpedo.addChild(SpriteUtils.make(DasUBootGameAssets.TORPEDO_BLANK, new PIXI.Point(-18, 426)));
        this._torpedo.position.y = -200;

        const propellerStill = SpriteUtils.make(DasUBootGameAssets.TORPEDO_PROPELLER_STILL, new PIXI.Point(4, 475));
        const propellerTextures = DasUBoot.assetLoader.getTextures(DasUBootGameAssets.TORPEDO_PROPELLER);
        const propellerAnim = new PIXI.AnimatedSprite(propellerTextures);
        propellerAnim.animationSpeed = 1;
        propellerAnim.position.set(-1, 424);
        this._torpedo.addChild(propellerStill);
        this._torpedo.addChild(propellerAnim);


        this.propeller = {
            still:propellerStill,
            anim:propellerAnim
        }

        this.updatePropeller();

        this.topView.addChild(this._torpedo);
    }


    public loadTorpedo():gsap.core.Timeline {
        this.createBlankTorpedo();
        this.torpedoBottomContainer.addChild(this.topView);
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add([
            gsap.to(this._torpedo, {duration:0.5, y:0}),
            () => DasUBoot.soundPlayer.playSound(DasUBootSound.TORPEDO_DOWN)
        ]);
        tl.add(() => {this.torpedoTopContainer.addChild(this.topView)});
        return tl;
    }

    public unLoadTorpedo(delay:number = 0):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {this.torpedoBottomContainer.addChild(this.topView)});
        tl.add([
            gsap.to(this._torpedo, {duration:0.5, y:-200}),
            () => DasUBoot.soundPlayer.playSound(DasUBootSound.TORPEDO_UP)
        ], "+=" + delay);
        tl.add(() => this.deleteTorpedo());
        return tl;
    }

    public deleteTorpedo() {
        if (this._torpedo != undefined) {
            this.topView.removeChild(this._torpedo);
        }
    }


    private getPartFlash():gsap.core.Timeline {
        const tl = gsap.timeline();

        const parts = [this.torpedoParts[1], this.torpedoParts[2], this.torpedoParts[3], this.torpedoParts[4]];

        for (let part of parts) {
            if (part) {
                part.getFlash()
            }
        }

        return tl;

    }

    private updatePropeller(runAnim:boolean = false) {
        if (this.propeller) {
            if (runAnim) {
                this.propeller.anim.visible = true;
                this.propeller.anim.play()
                this.propeller.still.visible = false;
            } else {
                this.propeller.anim.visible = false;
                this.propeller.anim.stop()
                this.propeller.still.visible = true;
            }
        }
    }
}